import { ErrorOutline, Flag, ReportProblem, Warning } from '@mui/icons-material';
import { formatDate } from '../../../utils/dateUtils';

export const priorityColor = (priority) => {
  switch (priority.toLowerCase()) {
    case 'urgent':
      return 'red';
    case 'high':
      return 'orange';
    case 'medium':
      return 'yellow';
    case 'low':
      return 'green';
    default:
      return '#e0e0e0';
  }
};

export const priorityIcon = (priority) => {
  switch (priority.toLowerCase()) {
    case 'urgent':
      return <Flag sx={{ color: priorityColor(priority), fontSize: '15px', mr: 1, alignItems: 'center' }} />;
    case 'high':
      return <Flag sx={{ color: priorityColor(priority), fontSize: '15px', mr: 1, alignItems: 'center' }} />;
    case 'medium':
      return <Flag sx={{ color: priorityColor(priority), fontSize: '15px', mr: 1, alignItems: 'center' }} />;
    case 'low':
      return <Flag sx={{ color: priorityColor(priority), fontSize: '15px', mr: 1, alignItems: 'center' }} />;
    default:
      return null;
  }
};

export const groupFeedbacksByDate = (feedbacks) => {
  const groups = {};
  feedbacks?.forEach((feedback) => {
    const dateStr = formatDate(feedback.datePosted);
    if (!groups[dateStr]) {
      groups[dateStr] = [];
    }
    groups[dateStr].push(feedback);
  });
  return groups;
};
